export default "__VITE_ASSET__BuntpaJ4__"